"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationUpdate = exports.useApplicationCreate = exports.useApplicationFetch = void 0;
const react_redux_1 = require("react-redux");
const applicationAction_1 = require("./applicationAction");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_router_dom_1 = require("react-router-dom");
function useApplicationFetch() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['application/fetch'].loading);
    const data = (0, react_redux_1.useSelector)((state) => state['application/fetch'].data);
    const error = (0, react_redux_1.useSelector)((state) => state['application/fetch'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const applicationFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, applicationAction_1.fetch)(fetchPayload));
    });
    return { loading, error, applicationFetch, data };
}
exports.useApplicationFetch = useApplicationFetch;
function useApplicationCreate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const applicationCreateLoading = (0, react_redux_1.useSelector)((state) => state['application/create'].loading);
    const applicationCreateData = (0, react_redux_1.useSelector)((state) => state['application/create'].data);
    const applicationCreateError = (0, react_redux_1.useSelector)((state) => state['application/create'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const applicationCreate = (createPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, applicationAction_1.create)(createPayload));
    });
    return { applicationCreateLoading, applicationCreateError, applicationCreate, applicationCreateData };
}
exports.useApplicationCreate = useApplicationCreate;
function useApplicationUpdate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const applicationUpdateLoading = (0, react_redux_1.useSelector)((state) => state['application/update'].loading);
    const applicationUpdateData = (0, react_redux_1.useSelector)((state) => state['application/update'].data);
    const applicationUpdateError = (0, react_redux_1.useSelector)((state) => state['application/update'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const applicationUpdate = (createPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, applicationAction_1.update)(createPayload));
    });
    return { applicationUpdateData, applicationUpdate, applicationUpdateLoading, applicationUpdateError };
}
exports.useApplicationUpdate = useApplicationUpdate;
